import styled from '@r360-tours/ui';

export const Main = styled.main`
  box-sizing: border-box;
  height: 100vh;
`;
